<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <!-- <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table> -->
    <Table :loading="loading" :columns="columns" :data="data"></Table>
    <div slot="footer">
      <Button :loading="loading" @click="hide()" type="primary">返回列表</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  data() {
    return {
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
      // table
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '车辆编号',
          minWidth: 100,
          key: 'carNo'
        },
        {
          title: '车牌号',
          minWidth: 100,
          key: 'licenseNo'
        },
        {
          title: '更新人',
          minWidth: 100,
          key: 'userName'
        },
        {
          title: '最后更新时间',
          key: 'modifyDatetime',
          minWidth: 100,
          render: (h, params) => {
            let row = params.row
            return h('div', this.$utils.datetime(row.modifyDatetime))
          }
        },
      ],
      data: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      selection: []
    }
  },

  computed: {
    itemTitle() {
      return '车辆更新时间'
    }
  },
  created() {

  },

  methods: {
    hide() {
      this.modalVisible = false
    },

    init(companyId) {
      this.id = companyId
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.list()
    },
    list() {
      this.loading = true
      this.$request.carChangeDetail(this.id).then(resp => {
        console.log(resp)
        this.loading = false
        if (!resp.code) {
          this.data = resp.data || []
          this.page.total = resp.data.total || 0
        }
      })
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },


  }
}

</script>
